import api from "./api";

export const getPaymentReport = async (params) => {
  return api
    .get({
      endpoint: "/reporting",
      port: process.env.REACT_APP_PORT_REPORT,
      queryParam: params,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
